import {
    isPossibleToUseWorker,
    createWorkerFromFunction
} from './utils'

/**
 * !!This function without external dependencies, because uses into workers
 *
 * Converts array of arrays of arrays to CSV string.
 * @param tables An array of 2d arrays
 * @param separator Separator string.
 * @param eol End of line string.
 */

// TODO: use this method instead of _json2csv.
function _jsonTables2csv(tables, separator, eol) {
    var str = "";
    for (var tInd = 0; tInd < tables.length; tInd++) {
        var table = tables[tInd];

        for (var i = 0; i < table.length; i++) {
            var line = '';
            var row = table[i];
            for (var j = 0; j < row.length; j++) {
                if (j !== 0)
                    line += separator;

                line += '"' + row[j].replace(/"/g, '""') + '"';
            }
            str += line + eol;
        }
    }

    return str;
}

/**
 * !!This function without external dependencies, because uses into workers
 *
 * Converts array of JSON to CSV string
 * @param jsons An array of objects containing following fields:
 *   columns - array of field to be presented in result csv string e.g. ["field1", "field2", "field3"]
 *   columnNames - map of header names {field1: "Main Field", field2: "Other Field", field3: "etc..."}
 *   table - array of jsons e.g.: [{field1: "hello", field2: "world"}, {field1: "hello", field3: "!"}, {field1: "the only field"}]
 * @param separator Separator string.
 * @param eol End of line string.
 */
function _json2csv(jsons, separator, eol) {
    var str = "";
    for (var jInd = 0; jInd < jsons.length; jInd++) {
        var json = jsons[jInd];
        var columns = json.columns;

        var columnNamesMap = json.columnNames;
        var table = json.table;

        if (columnNamesMap) {
            var columnNames = []
            for (var cInd = 0; cInd < columns.length; cInd++) {
                columnNames.push('"' + columnNamesMap[columns[cInd]].replace(/"/g, '""') + '"')
            }
            str += columnNames.join(separator) + eol;
        }

        var columnsLength = columns.length;
        for (var i = 0; i < table.length; i++) {
            var line = '';
            var row = table[i];
            for (var j = 0; j < columnsLength; j++) {
                if (j != 0)
                    line += separator;

                var value = row[columns[j]];
                if (value !== undefined)
                    line += '"' + value.replace(/"/g, '""') + '"';
            }

            str += line + eol;
        }
    }
    return str;
}

/**
 * Converts array of JSON to CSV string and returns the result in callback.
 * Depending on browser capabilities, CSV will be generated in separate thread or synchronously.
 * @param jsons See _json2csv() or _jsonTables2csv()
 * @param separator See _json2csv() or _jsonTables2csv()
 * @param eol See _json2csv() or _jsonTables2csv()
 * @param pureTable Used for choosing between _json2csv or _jsonTables2csv (if it false will use _json2csv)
 * @param callback Callback function with single parameter, which is result CSV string.
 */
export default function json2csv(jsons, separator, eol, pureTable, callback) {
    const converter = (pureTable) ? _jsonTables2csv : _json2csv

    if (isPossibleToUseWorker()) {
        const worker = createWorkerFromFunction(converter)
        worker.onerror = function() {
            // Failed to load the worker, proceed synchronously
            callback(converter(jsons, separator, eol));
        };
        worker.onmessage = function(e) {
            callback(e.data);
            worker.terminate();
        };
        worker.postMessage({
            args: [jsons, separator, eol]
        });
    }
    else {
        callback(converter(jsons, separator, eol));
    }
}




// WEBPACK FOOTER //
// ./web/js/json2csv/json2csv.js